import React, {Component} from 'react';
import styled from 'styled-components'
import {withRouter} from 'react-router-dom';
import {Box, Image} from 'rebass';
import {sortBy} from 'lodash-es'

import ChatCard from '../Cards/ChatCard'

import edit from "../../resources/img/icons/edit.png";

import { 
    Header,
    Right,
    Left,
    IconWrapper,
    LeftText
} from './Styles';

const ChatGroupListWrapper = styled(Box)`
    height: 400px;
    overflow-y: scroll;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #ffffff;
    background-color: #ffffff;
`

class ChatGroupList extends Component {
	constructor(props) {
		super(props);
		this.state = {
            createdChats: [],
            joinedChats: []
		};
	}

    componentDidMount() {
		this.joinedListener = this.fetchJoinedListener()
    }
    
    componentWillUnmount() {
		this.joinedListener()
	}

	joinAndSortChats = () => {
		const {createdChats, joinedChats} = this.state;
		let allChats = [...createdChats, ...joinedChats];
		let sortedChats = sortBy(allChats, [(item => item.last_updated)], 'desc');
		sortedChats = sortedChats.reverse();
		return sortedChats

    };
    
    fetchJoinedListener = () => {
		const {profile} = this.props;
		return this.props.firebase.chats().where('members', 'array-contains', profile.id).onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));

			this.setState({joinedChats: result})
		})
	};

   
	handleChatSelect = (item) => {
        this.props.switchMessageWindow(item.id);
    };
    
    onEditClick= (e) => {
		e.stopPropagation();
		this.props.edit();
	}

	render() {
        const chats = this.joinAndSortChats();
        const { profile, isMinimized } = this.props;
        return  (
            <>
                <Header onClick={this.props.toggleBox}>
                                    <Left
                                        p={3}
                                        width={3/4}
                                    >
                                        <LeftText>
                                            Chats
                                        </LeftText>
                                    </Left>
                                    <Right
                                        p={3}
                                        width={1/4}
                                    >
                                        <IconWrapper onClick={this.onEditClick}>
                                            <Image src={edit} />
                                        </IconWrapper>
                                    </Right>
                </Header>
                {
                    !isMinimized && 
                    <ChatGroupListWrapper>
                        { chats.map(item => 
                            <ChatCard 
                            key={item.id} 
                            item={item} 
                            handleClick={this.handleChatSelect}
                            profile={profile}/>)
                        }
                    </ChatGroupListWrapper>
                }
             </>
            )
        }
  }

export default withRouter(ChatGroupList)